export function floatWithDot(value) {
    return value !== null && value !== undefined
        ? parseFloat(value.toString().replace(/\s/g, '').replace('.', ','))
        : null;
}

export function convertToMoney(value) {
    return value.toLocaleString('lt-LT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export function commaValue(value, addZerosAfterDecimal = false) {
    if (addZerosAfterDecimal) {
        value = parseFloat(value).toLocaleString('lt-LT', {
            style: 'decimal',
            useGrouping: false,
            minimumFractionDigits: 2
        });
    }

    return format_money(value);
}

export function format_money(value = 0.00) {
    let regex = new RegExp('^[0-9,]+$');
    value = String(value);

    if (!regex.test(value)) {
        value = value.replace(/\./g, ',');
        value = value.replace(/[^0-9,]/g, '');
    }

    return value;
}

export function decodeData(val) {
    if (val !== null && val !== undefined) {
        return atob(val);
    }
    return '';
}
